/**
 * Paleta hex usada históricamente en @imj_media/tasks-modules (utils/Colors.tsx).
 * Copia literal para migrar consumidores hacia @imj_media/ui sin depender de tasks-modules.
 */
export const COLORS = {
  PRIMARY: {
    Light: {
      LIGHT: '#F1F4FF',
      MEDIUM: '#E1EBF9',
      DARK: '#28408F',
      REGULAR: '#3658C1',
    },
    Dark: {
      LIGHT: '#E7E9F2',
      MEDIUM: '#DAE2EC',
      DARK: '#334990',
      REGULAR: '#5C7DDD',
    },
  },
  SUCCESS: {
    Light: {
      LIGHT: '#F2FFF9',
      MEDIUM: '#DFF6ED',
      DARK: '#077444',
      REGULAR: '#039B59',
    },
    Dark: {
      LIGHT: '#E6E9ED',
      MEDIUM: '#D2E9DC',
      DARK: '#368156',
      REGULAR: '#43B071',
    },
  },
  DANGER: {
    Light: {
      LIGHT: '#FFF3F1',
      MEDIUM: '#F6E0DE',
      DARK: '#9C261C',
      REGULAR: '#C62E1F',
    },
    Dark: {
      LIGHT: '#F1E5E4',
      MEDIUM: '#EBDBD9',
      DARK: '#8C352C',
      REGULAR: '#C34335',
    },
  },
  WARNING: {
    Light: {
      LIGHT: '#FFFBF2',
      MEDIUM: '#F8EDDF',
      DARK: '#AE6D1E',
      REGULAR: '#DC8921',
    },
    Dark: {
      LIGHT: '#F2ECE5',
      MEDIUM: '#EBE3D9',
      DARK: '#B4782F',
      REGULAR: '#D38A31',
    },
  },
  ALERT: {
    Light: {
      LIGHT: '#FFFEF1',
      MEDIUM: '#F5F4DC',
      DARK: '#AEA51E',
      REGULAR: '#E1D63D',
    },
    Dark: {
      LIGHT: '#F1F1E4',
      MEDIUM: '#EAAE9D9',
      DARK: '#ADA63A',
      REGULAR: '#D6CC48',
    },
  },
  INFO: {
    Light: {
      LIGHT: '#E7F5FF',
      MEDIUM: '#D9E6EE',
      DARK: '#1C5073',
      REGULAR: '#1B6698',
    },
    Dark: {
      LIGHT: '#E7F5FF',
      MEDIUM: '#D9E6EE',
      DARK: '#1C5073',
      REGULAR: '#1B6698',
    },
  },
  LINK: {
    Light: {
      LIGHT: '#ECF8FE',
      MEDIUM: '#D8F1FD',
      DARK: '#0A7AAE',
      REGULAR: '#0EA5E9',
    },
    Dark: {
      LIGHT: '#ECF8FE',
      MEDIUM: '#D8F1FD',
      DARK: '#0A7AAE',
      REGULAR: '#0EA5E9',
    },
  },
  BLACK: {
    LIGHT: '#929292',
    MEDIUM: '#4F4F4F',
    DARK: '#131313',
    REGULAR: '#252525',
  },
  GRAY: {
    LIGHT: '#D9D9D9',
    DARK: '#C4C4C4',
    REGULAR: '#D1D1D1',
  },
  SILVER: {
    WHITE: '#FAFAFA',
    LIGHT: '#F5F5F5',
    DARK: '#E9E9E9',
    REGULAR: '#EFEFEF',
  },
  IMJ: {
    Light: '#0095c6',
    Dark: '#f1e323',
  },
  BUTTONS: {
    PRIMARIO: {
      Light: '#126EFA',
      Dark: '#126EFA',
    },
    SECUNDARIO: {
      Light: '#FC3D38',
      Dark: '#FC3D38',
    },
    TERCIARIO: {
      Light: '#7BAFFF',
      Dark: '#7BAFFF',
    },
  },
  MESSAGE: {
    SUCCESS: {
      Light: '#038f39',
      Dark: '#038f39',
    },
    ERROR: {
      Light: '#da3430',
      Dark: '#da3430',
    },
    WARNING: {
      Light: '#f8b03d',
      Dark: '#f8b03d',
    },
  },
  BG: {
    Light: '#ffffff',
    Dark: '#2c2926',
  },
  FONTS: {
    '30%': {
      Light: '#bdbaba',
      Dark: '#656262',
    },
    '60%': {
      Light: '#54514f',
      Dark: '#8d8989',
    },
    '90%': {
      Light: '#343232',
      Dark: '#bdbaba',
    },
  },
} as const;

export type TasksModulesColors = typeof COLORS;
